const WEB = 'web';
const MOBILE = 'mobile';
const PLATFORMS = [WEB, MOBILE];

export { PLATFORMS, WEB, MOBILE };
